import postAPI from './postAPI.js'

export default async function getActionDeliveries(payload) {
    const data = await postAPI('admin/taskflows/actions/deliveries', payload);
    return data;
}
